const backgroundOrigin = {
  name: "background-origin",
  path: "/background-origin",
  title: "background-origin",
  description: "Utilities for controlling an element's background origin.",
  value: {
    "background-origin": {
      "bg-origin-border": "border-box",
      "bg-origin-padding": "padding-box",
      "bg-origin-content": "content-box",
    }
  },
  exampleData: [
    {
      example: {
        code: `
<div class="bg-image-[url(https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=800&q=80)] bg-origin-border bg-cover h-32"></div>
<div class="bg-image-[url(https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=800&q=80)] bg-origin-padding bg-cover h-32"></div>
<div class="bg-image-[url(https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=800&q=80)] bg-origin-content bg-cover h-32"></div>
        `
      }
    }
  ],
  htmlData: [
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:bg-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">bg-origin-*</code> utilities to control the background origin of an element.
      </p>
      <div class="mx-auto justify-around flex gap-4">
        <div>
        <p class="mb-2 font-mono text-xs font-medium text-color-gray-500 dark:text-color-gray-400">bg-origin-border</p>
          <div class="p-3 bg-image-[url(https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=800&q=80)] bg-origin-border bg-cover size-32 rounded-lg border-3 border-color-red-500/50 border-style-dashed"></div>
        </div>
        <div>
        <p class="mb-2 font-mono text-xs font-medium text-color-gray-500 dark:text-color-gray-400">bg-origin-padding</p>
          <div class="p-3 bg-image-[url(https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=800&q=80)] bg-origin-padding bg-cover size-32 rounded-lg border-3 border-color-red-500/50 border-style-dashed"></div>
        </div>
        <div>
        <p class="mb-2 font-mono text-xs font-medium text-color-gray-500 dark:text-color-gray-400">bg-origin-content</p>
          <div class="p-3 bg-color-gray-200 bg-image-[url(https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=800&q=80)] bg-origin-content bg-cover size-32 rounded-lg border-3 border-color-red-500/50 border-style-dashed"></div>
        </div>
      </div>
      `
    }
  ]
};

export default backgroundOrigin;

<div className="bg-origin-border bg-origin-padding bg-origin-content border-3 border-color-red-500/50 border-style-dashed"></div>